import moment from 'moment'

export default (str, format, lang = 'pt-BR', timezone) => {
  let date = moment(str)

  if (timezone) {
    date = date.tz(timezone)
  }

  if (format === 'birthDay') {
    return moment().diff(moment(str), 'years')
  } else if (format === 'fromNow') {
    return date.locale(lang).fromNow()
  } else {
    return date.format(format)
  }
}



// WEBPACK FOOTER //
// ./src/filters/Moment.js